// 认证相关的工具函数

/**
 * 获取token
 * @returns {string} token字符串
 */
export function getToken () {
  return localStorage.getItem('authorization') || ''
}

/**
 * 设置token
 * @param {string} token - 认证token
 */
export function setToken (token) {
  localStorage.setItem('authorization', token)
}

/**
 * 移除token
 */
export function removeToken () {
  localStorage.removeItem('authorization')
}

/**
 * 检查用户是否已登录
 * @returns {boolean} 是否已登录
 */
export function isLoggedIn () {
  const token = getToken()
  return token !== null && token !== 'null' && token !== ''
}

/**
 * 保存用户信息
 * @param {Object} userInfo - 用户信息对象
 */
export function setUserInfo (userInfo) {
  localStorage.setItem('userInfo', JSON.stringify(userInfo))
}

/**
 * 获取用户信息
 * @returns {Object} 用户信息对象
 */
export function getUserInfo () {
  const userInfo = localStorage.getItem('userInfo')
  return userInfo ? JSON.parse(userInfo) : null
}

/**
 * 清除用户信息
 */
export function clearUserInfo () {
  localStorage.removeItem('userInfo')
}

/**
 * 退出登录
 */
export function logout () {
  removeToken()
  clearUserInfo()
}
